module.exports = __webpack_public_path__ + "static/media/DocumentSymbol.32c6c53a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/DocumentSymbol.svg
// module id = 570
// module chunks = 1